export const PartnershipRoutes = {
  microsoft:
    'https://appsource.microsoft.com/ru-RU/marketplace/partner-dir/e6ce33ad-69d4-4052-8225-4d0e0d2ac5f7/overview',
} as const
